import { render, staticRenderFns } from "./booking-board.vue?vue&type=template&id=8a99eabe&scoped=true"
import script from "./booking-board.vue?vue&type=script&lang=js"
export * from "./booking-board.vue?vue&type=script&lang=js"
import style0 from "./booking-board.vue?vue&type=style&index=0&id=8a99eabe&prod&lang=css"
import style1 from "./booking-board.vue?vue&type=style&index=1&id=8a99eabe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a99eabe",
  null
  
)

export default component.exports